export function getOnlineAt(previewDate?: string): number | undefined {
    if (!previewDate) return undefined;

    const onlineAt = Date.parse(previewDate);
    return Number.isFinite(onlineAt) ? onlineAt : undefined;
}
